function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { nothing as $, html as r } from "../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { customElement as w } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as m } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { state as f } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/state.js";
import T from "../../../packages/web-components/src/components/table/table.tokens.scss.js";
import k from "../../../packages/web-components/src/components/table/gator/table.gator.scss.js";
import y from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import R from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { NjcTable as P } from "../table.js";
import "../../checkbox/checkbox.gator.js";
import "./table-bulk-controls/table-bulk-controls.gator.js";
import { unsafeHTML as C } from "../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/directives/unsafe-html.js";
import { msg as b } from "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import "../../skip-link/gator/base/skip-link.gator.js";
import { unsafeCSS as p } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var B = Object.defineProperty,
  S = Object.getOwnPropertyDescriptor,
  h = function h(e, t, l, s) {
    for (var a = s > 1 ? void 0 : s ? S(t, l) : t, i = e.length - 1, n; i >= 0; i--) (n = e[i]) && (a = (s ? n(t, l, a) : n(a)) || a);
    return s && a && B(t, l, a), a;
  };
var c = /*#__PURE__*/function (_P) {
  function c() {
    var _this;
    _classCallCheck(this, c);
    _this = _callSuper(this, c, arguments), _this.elevated = !1, _this.includePagination = !1, _this.selectedRows = [], _this._currentPage = 1;
    return _this;
  }
  _inherits(c, _P);
  return _createClass(c, [{
    key: "updated",
    value: function updated(e) {
      _superPropGet(c, "updated", this, 3)([e]), e.has("data") && (this.selectedRows = this.data.filter(function (t) {
        return t.selected && !t.isTableHeader;
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.columns ? this.renderWrapper(this.getTableHeader(this.columns), this.getTableBody(this.columns, this.displayedRowData)) : null;
    }
  }, {
    key: "tableElevatedClass",
    get: function get() {
      return this.elevated ? "gator-table-elevated" : "";
    }
  }, {
    key: "showBulkControls",
    get: function get() {
      return this.selectable && this.selectedRows.length > 0;
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(e, t) {
      return r(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <ngc-table-bulk-controls\n                ?visible=\"", "\"\n                .selectedRows=\"", "\"\n                .totalRows=\"", "\"\n                ?allSelected=\"", "\"\n                @selectall=\"", "\"\n            >\n                <slot name=\"bulk-controls\"></slot>\n            </ngc-table-bulk-controls>\n            <table class=\"gator-table ", "\" role=\"grid\"\n                   aria-labelledby=\"", "\">\n                ", " ", "\n            </table>\n            ", "\n        "])), this.showBulkControls, this.selectedRows.length, this.data.length, this.selectedRows.length === this.data.length, this.handleSelectAll, this.tableElevatedClass, this.tableAriaLabelledBy, e, t, this.includePagination ? r(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                <ngc-table-pagination\n                    items-per-page=\"", "\"\n                    total-items=\"", "\"\n                    current-page=\"", "\"\n                    @pagechanged=\"", "\"\n                    @itemsperpagechanged=\"", "\"\n                ></ngc-table-pagination>\n            "])), this.itemsPerPage, this.data.length, this._currentPage, this.handlePageChanged, this.handleItemsPerPageChanged) : $);
    }
  }, {
    key: "handlePageChanged",
    value: function handlePageChanged(e) {
      this._currentPage = e.detail.page;
    }
  }, {
    key: "handleItemsPerPageChanged",
    value: function handleItemsPerPageChanged(e) {
      this.itemsPerPage = e.detail.itemsPerPage;
    }
  }, {
    key: "getTableHeader",
    value: function getTableHeader(e) {
      var _this2 = this;
      var t = e.map(this.getTableHeaderColumn);
      return this.selectable && t.unshift(r(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                <th id=\"col-select\" scope=\"col\">\n                    <ngc-checkbox\n                        title-text=\"", "\"\n                        hide-label\n                        ?selected=\"", "\"\n                        @change=\"", "\"\n                    ></ngc-checkbox>\n                </th>"])), b("Select All"), this.selectedRows.length === this.data.length, function (l) {
        return _this2.handleSelectAll(l);
      })), r(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <thead role=\"rowgroup\">\n              <tr role=\"row\">\n                  ", "\n              </tr>\n            </thead>\n        "])), t);
    }
  }, {
    key: "handleSelectAll",
    value: function handleSelectAll(e) {
      var t = e.detail.selected;
      t ? (this.data.forEach(function (l) {
        l.isTableHeader || (l.selected = !0);
      }), this.selectedRows = this.data.filter(function (l) {
        return !l.isTableHeader;
      })) : (this.data.forEach(function (l) {
        l.selected = !1;
      }), this.selectedRows = []), this.dispatchEvent(new CustomEvent("selectall", {
        bubbles: !0,
        detail: {
          selectedRows: this.selectedRows,
          selected: t
        }
      })), this.requestUpdate();
    }
  }, {
    key: "getTableHeaderColumn",
    value: function getTableHeaderColumn(e) {
      var t = "col-".concat(e.field);
      return r(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            <th id=\"", "\" scope=\"col\">", "</th>"])), t, e.name);
    }
  }, {
    key: "getTableBody",
    value: function getTableBody(e, t) {
      var _this3 = this;
      var l = [];
      var s = {
        rows: []
      };
      return t.forEach(function (a) {
        a.isTableHeader ? ((s.rows.length > 0 || s.header) && l.push(s), s = {
          header: a,
          rows: []
        }) : s.rows.push(a);
      }), (s.rows.length > 0 || s.header) && l.push(s), l.length === 0 && t.length > 0 && l.push({
        rows: t
      }), r(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", "\n        "])), l.map(function (a) {
        return _this3.getCategoryBody(a, e);
      }));
    }
  }, {
    key: "getCategoryBody",
    value: function getCategoryBody(e, t) {
      var _this4 = this;
      var l = "",
        s = "",
        a = "";
      e.header && (l = e.header.headerText || e.header.categoryText || e.header.name || "Category", a = "category-".concat(l.toLowerCase().replace(/\s+/g, "-")), s = a);
      var i = e.header ? this.getTableHeaderRow(t, e.header) : "",
        n = e.rows.map(function (d) {
          return _this4.getTableBodyRow(d, t, a);
        }),
        u = t.some(function (d) {
          return d.includedInTotals === !0;
        }),
        o = e.rows.length > 0 && u ? this.getTotalRow(e.rows, t, a) : "";
      return r(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            <tbody role=\"rowgroup\" ", ">\n              ", "\n              ", "\n              ", "\n            </tbody>\n        "])), s ? r(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["aria-labelledby=\"", "\""])), s) : "", i, n, o);
    }
  }, {
    key: "getTotalRow",
    value: function getTotalRow(e, t, l) {
      var _this5 = this;
      var s = {};
      t.forEach(function (o) {
        s[o.field] = 0, o.includedInTotals && e.forEach(function (d) {
          var g = _this5.parseNumericValue(d[o.field]);
          g !== null && (s[o.field] += g);
        });
      });
      var a = l ? "".concat(l, "-total") : "total-row",
        i = r(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            <th\n                id=\"", "\"\n                scope=\"row\"\n                class=\"gator-table-total-label\"\n            >\n                Total\n            </th>\n        "])), a),
        n = t.map(function (o) {
          var d = "col-".concat(o.field),
            g = [a, l, d].filter(Boolean).join(" ");
          return o.includedInTotals ? r(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n                    <td\n                        role=\"gridcell\"\n                        headers=\"", "\"\n                        class=\"gator-table-total-cell\"\n                    >\n                        ", "\n                    </td>\n                "])), g, _this5.formatTotal(s[o.field], o)) : r(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n                    <td\n                        role=\"gridcell\"\n                        class=\"gator-table-total-cell\"\n                    >\n                        &nbsp;\n                    </td>\n                "])));
        }),
        u = this.selectable ? [i].concat(_toConsumableArray(n)) : [i].concat(_toConsumableArray(n.slice(1)));
      return r(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            <tr role=\"row\" class=\"gator-table-total-row\">\n                ", "\n            </tr>\n        "])), u);
    }
  }, {
    key: "parseNumericValue",
    value: function parseNumericValue(e) {
      if (typeof e == "number") return e;
      if (typeof e == "string") {
        var t = e.replace(/[^0-9.-]/g, ""),
          l = parseFloat(t);
        if (!isNaN(l)) return l;
      }
      return null;
    }
  }, {
    key: "formatTotal",
    value: function formatTotal(e, t) {
      var l = typeof t.decimalPlaces == "number" ? t.decimalPlaces : 2,
        s = e.toFixed(l);
      return typeof t.cellRenderer == "function" ? t.cellRenderer(_defineProperty({}, t.field, s)) : s;
    }
  }, {
    key: "getTableBodyRow",
    value: function getTableBodyRow(e, t, l) {
      var _this6 = this;
      var s = t.map(function (a) {
        return _this6.getTableBodyCell(e, a, l);
      });
      if (this.selectable) {
        var a = l ? "col-select ".concat(l) : "col-select";
        s.unshift(r(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n                <td role=\"gridcell\" class=\"gator-table-checkbox-column\" headers=\"", "\">\n                    <ngc-checkbox\n                        label=\"test\"\n                        ?selected=\"", "\"\n                        @change=\"", "\"\n                        id=\"checkbox-", "\"\n                    ></ngc-checkbox>\n                </td>"])), a, e.selected, function (i) {
          return _this6.handleTableBodyRowSelected(i, e);
        }, e.id || Math.random().toString(36).substring(2, 11)));
      }
      return r(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            <tr role=\"row\" class=\"", "\">\n                ", "\n            </tr>\n        "])), this.selectable && e.selected ? "gator-table-row-selected" : "", s);
    }
  }, {
    key: "getTableHeaderRow",
    value: function getTableHeaderRow(e, t) {
      var l = this.selectable ? e.length + 1 : e.length,
        s = t.headerText || t.categoryText || t.name || "Category";
      return r(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            <tr role=\"row\" class=\"gator-table-category-header\">\n                <th role=\"rowheader\" colspan=\"", "\" scope=\"rowgroup\" class=\"gator-table-header-cell\"\n                    id=\"", "\">\n                    ", "\n                </th>\n            </tr>\n        "])), l, "category-".concat(s.toLowerCase().replace(/\s+/g, "-")), s);
    }
  }, {
    key: "handleTableBodyRowSelected",
    value: function handleTableBodyRowSelected(e, t) {
      e.detail.selected ? (t.selected = !0, this.selectedRows.push(t), this.addSkipLinkToBulkActions(e.target)) : (t.selected = !1, this.selectedRows = this.selectedRows.filter(function (l) {
        return l !== t;
      }), this.removeSkipLinkToBulkActions(e.target)), this.dispatchEvent(new CustomEvent("rowselected", {
        bubbles: !0,
        detail: {
          data: t,
          selectedRows: this.selectedRows
        }
      })), this.requestUpdate();
    }
  }, {
    key: "addSkipLinkToBulkActions",
    value: function addSkipLinkToBulkActions(e) {
      var _e$parentNode, _e$parentNode2;
      ((_e$parentNode = e.parentNode) === null || _e$parentNode === void 0 ? void 0 : _e$parentNode.querySelector("ngc-skip-link")) || ((_e$parentNode2 = e.parentNode) === null || _e$parentNode2 === void 0 ? void 0 : _e$parentNode2.insertBefore(this.getSkipToBulkActionsMarkup(e), e));
    }
  }, {
    key: "getSkipToBulkActionsMarkup",
    value: function getSkipToBulkActionsMarkup(e) {
      var _this$shadowRoot;
      var t = document.createElement("ngc-skip-link");
      return t.target = ((_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector("ngc-table-bulk-controls")) || "", t.text = b("Jump to table actions"), t.referenceElement = e, t.placement = "top-start", t.xOffset = 4, t.yOffset = -12, t.onblur = this.removeSkipLinkToBulkActions.bind(this, e), t;
    }
  }, {
    key: "removeSkipLinkToBulkActions",
    value: function removeSkipLinkToBulkActions(e) {
      var _e$parentNode3;
      (_e$parentNode3 = e.parentNode) === null || _e$parentNode3 === void 0 || (_e$parentNode3 = _e$parentNode3.querySelector("ngc-skip-link")) === null || _e$parentNode3 === void 0 || _e$parentNode3.remove();
    }
  }, {
    key: "displayedRowData",
    get: function get() {
      if (!this.includePagination) return this.data;
      var e = (this._currentPage - 1) * this.itemsPerPage,
        t = e + this.itemsPerPage;
      return this.data.slice(e, t);
    }
  }, {
    key: "getTableBodyCell",
    value: function getTableBodyCell(e, t, l) {
      var s = "col-".concat(t.field),
        a = l ? "".concat(s, " ").concat(l) : s;
      return r(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            <td role=\"gridcell\" headers=\"", "\">\n                ", "\n            </td>\n        "])), a, C(this.getValueForCell(e, t)));
    }
  }, {
    key: "getValueForCell",
    value: function getValueForCell(e, t) {
      return typeof t.cellRenderer == "function" ? t.cellRenderer(e) : e[t.field];
    }
  }]);
}(P);
c.styles = [p(R), p(y), p(T), p(k)];
h([m({
  type: Boolean
})], c.prototype, "elevated", 2);
h([m({
  type: Boolean,
  attribute: "include-pagination"
})], c.prototype, "includePagination", 2);
h([f()], c.prototype, "selectedRows", 2);
h([f()], c.prototype, "_currentPage", 2);
c = h([w("ngc-table")], c);
export { c as NgcTable };